import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '../../cn';

const ButtonGroup = ({
  options = [],
  value,
  onChange,
  className = '',
  size = 'md',
  name
}) => {
  const sizeClasses = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-3 py-2 text-sm',
    lg: 'px-4 py-2.5 text-base'
  };

  return (
    <span className={cn('isolate inline-flex rounded-md shadow-sm', className)} role="group" aria-label={name}>
      {options.map((option, index) => {
        const isFirst = index === 0;
        const isLast = index === options.length - 1;
        const isActive = value === option.value;

        return (
          <button
            key={option.value}
            type="button"
            aria-pressed={isActive}
            onClick={() => onChange?.(option.value)}
            disabled={option.disabled}
            className={cn(
              'relative inline-flex items-center font-semibold ring-1 ring-inset ring-gray-300 focus:z-10 transition-all',
              sizeClasses[size],
              isFirst ? 'rounded-l-md' : '-ml-px',
              isLast ? 'rounded-r-md' : '',
              isActive
                ? 'bg-primary-600 text-white ring-primary-600 hover:bg-primary-700'
                : 'bg-white text-gray-900 hover:bg-gray-50'
            )}
          >
            {option.label}
          </button>
        );
      })}
    </span>
  );
};

ButtonGroup.displayName = 'ButtonGroup';

ButtonGroup.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]).isRequired,
    label: PropTypes.node.isRequired,
    disabled: PropTypes.bool
  })),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  onChange: PropTypes.func,
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  name: PropTypes.string
};

export default ButtonGroup;
